<template>
  <FilterForm
      :formData="filterData"
      :filters="filters"
      @changeDept="changeDept"
      @submit="handleSubmit"
      @reset="handleReset"
  />
  <div style="height: 400px; margin-top: 20px" ref="liveChart"></div>
</template>

<script>
import FilterForm from "@/components/filter";
// 引入echarts
import * as echarts from "echarts/core";
// 引入提示框，标题，直角坐标系等组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
} from "echarts/components";
// 引入图表类型，图表后缀都为 Chart
import { BarChart } from "echarts/charts";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
// 引入 处理时间日期得 day.js
import {onMounted, reactive, ref} from "vue";
import { useStore } from "vuex";
import { getUserByDept } from "@/api/method/common";
import { getCustomerVisitStar } from "@/api/method/customer-visit";
import { reset } from "@/until";
/**
 * @description: 生成30条数据
 * @param {*}
 * @return {*}
 */
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
]);
export default {
  name: "visitStatistics",
  components: {
    FilterForm
  },
  setup() {
    const { dispatch, state } = useStore();
    const liveChart = ref(null);
    const myChart = ref(null);

    /**
     * @description: 拆箱函数,解决tooltip显示问题
     * @param {*}
     * @return {*}
     */
    const unwarp = function (obj) {
      return obj && (obj.__va_raw || obj.valueOf() || obj);
    };
    const buildData = async () => {
      const { date, ...param } = filterData;
      const startTime = date && date[0];
      const endTime = date && date[1];
      const res = await getCustomerVisitStar({
        ...param,
        startTime,
        endTime,
      })

      const op1 = {
        tooltip: {
          trigger: "item",
          axisPointer: {
            show: true,
            type: 'shadow',
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: res.data.names,
            axisTick: {
              alignWithLabel: true
            },
            triggerEvent: true
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '60%',
            data: res.data.counts,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' ml';
              }
            },
          }
        ]
      };

      let option = {
        title: {
          text: "来访星级统计图",
        },
        tooltip: {
          trigger: "item"
        },
        grid: {
          left: "0",
          right: "0",
          top: "10%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: res.data.names,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: res.data.counts,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      };

      console.log(op1)
      myChart.value = echarts.init(liveChart.value);
      unwarp(myChart.value).setOption(option);
    }

    onMounted(() => {
      getDepartList();
      buildData();
    });

    const filterData = reactive({
      deptId: null,
      userId: null,
      date: null,
    });
    const filters = reactive([
      [
        {
          label: "选择部门",
          type: "select",
          attr: "deptId",
          placeholder: "请选择",
          column: 6,
          option: [],
          labelWidth: "80px",
        },
        {
          label: "选择顾问",
          type: "select",
          attr: "userId",
          placeholder: "请选择",
          column: 6,
          option: [],
          labelWidth: "100px",
        },
        {
          label: "上门时间",
          type: "dateRange",
          attr: "date",
          column: 8,
          labelWidth: "80px",
          valueFormat: "YYYY-MM-DD",
        },
        {
          type: "button",
          column: 4,
        },
      ],
    ]);

    const getDepartList = async () => {
      await dispatch("departmentList");
      filters[0][0].option = state.departmentList.map((item) => ({
        label: item.fullName,
        val: item.id,
      }));
    };
    const changeDept = async (id) => {
      const res = await getUserByDept(id);
      filters[0][1].option = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
    };

    const handleSubmit = () => {
      buildData();
    };
    const handleReset = () => {
      reset(filterData);
      buildData();
    };

    return { liveChart, myChart ,filterData,filters,handleSubmit,handleReset,changeDept};
  },
};
</script>

<style lang="scss" scoped></style>
